export default "__VITE_ASSET__uML3YLS8__";